import RolePlayDetailComponent from "../../components/NewDesign/RolePlay/RolePlayDetailComponent"
import Page from "../../components/Page"

const RolePlayDetailPage = () => {
    return (
        <Page>
            <RolePlayDetailComponent />
        </Page>
    )
}

export default RolePlayDetailPage